import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./securityVerificationPopUp.css";
import { Row, Col, Button } from "react-bootstrap";
import { Header } from "../../../Shared";
import InputMask from "react-input-mask";

class SecurityVerificationPopUp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: "",
    }
  }

  validateCode(number) {
    const pattern = /[0-9]{4}$/im
    const result = pattern.test(number);
    return result;
    };

    onChange = (event) => {     
        this.setState({
            value:event.target.value,
        })
    }
    
    beforeMaskedValueChange = ({ nextState }) => {
        var value = nextState.value;
        var selection = nextState.selection;
        var newstring = ""; 
        if (value !== "")
        {
            var code = value.length;
            newstring = value.replace(/[_]/g, "");  
            selection.start = newstring.length;
            selection.end = newstring.length;
            var cursorPostion = selection ? selection.start : null;
            selection = { start: cursorPostion, end: cursorPostion }
            while (newstring.length < code) {
                newstring += "_";
            }
            value = newstring
        }
        
        return {
            value,
            selection
        };
    }

  render() {
    return (
      <div className="contentContainer">
        <div classname="Row">
                <span className="notifymessage">One-time code has been sent</span>
        </div>
        <Header
          mainHeading={"Security Confirmation"}
          subHeadingDesc={
            "For the safety of your accounts, please enter the One-Time Code sent to the email or phone number you provided."}
          popUpHide={true}
        />
        <hr className="lineHr"></hr>
        <Row className="alignSubHeading">
          <Col>One-Time Code</Col>
        </Row>

        <div className="displayFlex">
            <label aria-label="input-text">
            <InputMask mask="99999999"
             type="text"
              alwaysShowMask={true}
              value={this.state.value}
              onChange={this.onChange}  
              beforeMaskedStateChange={this.beforeMaskedValueChange}          
              className="popUpTextBox"
            />
          </label>
          <Button variant="Link" className="AppLink colrightalign" onClick={this.props.resendCode}>
            Resend One-Time Code
            </Button>

        </div>
            {!this.validateCode(this.state.value) && <div className="invalid-feedback-message bold"> *Please enter One-Time Code </div>}
        <div className="aligntextcontent displayFlex">

          <Button variant="success" className="custom-buttonForPopUp"  onClick={() => {
                    this.props.onSubmit(this.state.value)
          }}>
            Submit
            </Button>
          <Button aria-label={`cancel link on Security Confirmation popup`}
            variant="Link"
            className="AppLink left-margin" onClick={this.props.onCancel}>
            Cancel
            </Button>
        </div>
      </div>
    );
  }
}
export default SecurityVerificationPopUp;
